import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useUser } from "~/Context/userContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "react-axios";

import { getProfileContact } from "~/api/getChim";
import { validateNonAuth, validateAuth } from "./ContactValidationRules";
import useTrackCommentForm from "../useTrackCommentForm";
import ReCAPTCHA from "react-google-recaptcha";

import styled from "styled-components";

import "~/css/forms.less";

export const Wrapper = styled.section`
  margin: 10px 0 80px 0;
`;

const Contact = ({ userTo, userFrom: user, onComplete, onFailure }) => {
  let history = useHistory();
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);
  const recaptchaRef = React.createRef();

  const initialFormValues = { recaptchaValue: null };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const postContact = async () => {
    setLoading(true);

    const payload = {
      g_recaptcha_response: (recaptchaRef.current && recaptchaRef.current.getValue()) || null,
      name: inputs.name,
      subject: inputs.subject,
      to_chimdir: userTo,
      from_chimdir: (user.loggedin && user.user.dir) || null,
      email: inputs.email_address,
      message: inputs.message,
    };

    try {
      await getProfileContact(axios, payload);
      setLoading(false);
      onComplete();
    } catch (err) {
      setLoading(false);
      onFailure();
    }
  };

  const backButton = () => {
    history.push(`/profile/${userTo}`);
  };

  const validate = !loading && userState.loggedin ? validateAuth : validateNonAuth;

  const { inputs, handleInputChange, handleSubmit, errors } = useTrackCommentForm(initialFormValues, postContact, validate);

  const subjects = {
    "cs-1": "I love your Tracks!",
    "cs-2": "Such the track right there",
    "cs-3": "Keep on posting tracks!",
    "cs-4": "What the hell ?",
    "cs-5": "Feel Free!",
    "cs-6": "A message from a buddy on TOTD",
    "cs-7": "Track of the Day is the best",
  };

  function onCaptchaChange(value) {
    inputs.recaptchaValue = value;
  }

  function onCaptchaError() {
    console.log("Captcha Error");
    inputs.recaptchaValue = null;
  }

  return (
    <Wrapper className="ContactFormWrapper">
      <Form className="totd-form totd-form-horizontal Contact-form" noValidate onSubmit={(e) => handleSubmit(e)}>
        <Row>
          <Col xs={12} md={6} className="profile-edit-left">
            {/* <p>Left Side</p> */}
            <Form.Group as={Row} className={errors.name ? "error" : ""}>
              <Col md={10}>
                <Form.Label>Your Name:</Form.Label>
                {user.loggedin && user.isChim && <div>{user.user.full_name} Chimney</div>}
                {user.loggedin && !user.isChim && <div>{user.user.full_name}</div>}
                {!user.loggedin && (
                  <div>
                    <Form.Control
                      name="name"
                      onChange={handleInputChange}
                      value={inputs.name || ""}
                      type="text"
                      autoComplete="off"
                      required
                    />
                    {errors.name && <span className="help error">{errors.name}</span>}
                  </div>
                )}
              </Col>
            </Form.Group>
            {!user.loggedin && (
              <Form.Group as={Row} className={errors.email_address ? "error" : ""}>
                <Col md={10}>
                  <Form.Label>Email address:</Form.Label>
                  <Form.Control
                    name="email_address"
                    onChange={handleInputChange}
                    value={inputs.email_address || ""}
                    type="email"
                    autoComplete="off"
                    required
                  />
                  {errors.email_address && <span className="help error">{errors.email_address}</span>}
                </Col>
              </Form.Group>
            )}

            <Form.Group controlId="subject" as={Row} className={errors.subject ? "error" : ""}>
              <Col md={10}>
                <Form.Label>Subject:</Form.Label>
                <Form.Control name="subject" as="select" required onChange={handleInputChange}>
                  <option value=""></option>
                  {Object.keys(subjects).map((k) => (
                    <option key={k} value={k}>
                      {subjects[k]}
                    </option>
                  ))}
                </Form.Control>
                {errors.subject && <span className="help error">{errors.subject}</span>}
              </Col>
            </Form.Group>

            {!user.loggedin && (
              <Form.Group as={Row}>
                <Col md={10}>
                  <Form.Label>Confirm you are human:</Form.Label>
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6Lc8ZQwTAAAAAHTW5ccZa_qklcVAXncCSw-mxB-8"
                    onExpired={onCaptchaError}
                    onErrored={onCaptchaError}
                    onChange={onCaptchaChange}
                  />
                  {errors.recaptchaValue && <span className="help error">{errors.recaptchaValue}</span>}
                </Col>
              </Form.Group>
            )}
          </Col>
          <Col xs={12} md={6} className="profile-edit-right">
            {/* Right Side */}

            <Form.Group as={Row} className={errors.message ? "error" : ""}>
              <Col md={10}>
                <Form.Label>Message:</Form.Label>
                <Form.Control
                  disabled={loading}
                  name="message"
                  onChange={handleInputChange}
                  value={inputs.message || ""}
                  as="textarea"
                  rows="8"
                />
                {errors.message && <span className="help error">{errors.message}</span>}
              </Col>
            </Form.Group>

            <Col md={10}>
              <Button disabled={loading} variant="success" type="submit">
                Send Message
              </Button>
              <Button style={{ float: "right" }} onClick={(e) => backButton(e)} disabled={loading} variant="cancel" type="cancel">
                Cancel
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default Contact;
